import * as React from 'react';
import Button from '@mui/material/Button';
import errorResponses from '../../errorResponses';
import useDeleteField from '../hooks/useDeleteField';
import { AppContext } from '../../App';
import { useQueryClient } from '@tanstack/react-query';
import Delete from '@mui/icons-material/Delete';
import ButtonGlynt from '../common/Buttons/ButtonGlynt';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface IProps {
  fieldId: string;
  fieldLabel: string;
  trainingSetId?: string;
}

const DeleteField: React.FC<IProps> = ({ fieldId, fieldLabel, trainingSetId }) => {
  const { setToast } = React.useContext(AppContext);
  const client = useQueryClient();
  const theme = useTheme();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseConfirmation = () => {
    setOpen(false);
  };

  const { mutate: deleteField, isPending: isLoading } = useDeleteField({
    onSuccess: () => {
      setToast({
        open: true,
        message: 'Field Deleted.',
        variant: 'success',
      });
      client.invalidateQueries({
        queryKey: ['fields']
      });
    },
    onError: () => {
      setToast({
        open: true,
        message: errorResponses.failedToDeleteField,
        variant: 'error',
      });
    },
    onMutate: () => {
      handleCloseConfirmation();
    },
  }, trainingSetId);

  return (
    <>
      <Tooltip placement="top" title={`Delete Field`} disableFocusListener disableTouchListener>
        <ButtonGlynt
          data-cy={`btn-field-delete-${fieldLabel}`}
          variant="outlined"
          size="small"
          startIcon={<Delete style={{ fontSize: '20px' }} />}
          onClick={handleClickOpen}
          color="error"
        >
          Delete
        </ButtonGlynt>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleCloseConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this field?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmation}>Cancel</Button>
          <Button
            onClick={() => {
              deleteField(fieldId);
            }}
            autoFocus
            data-cy="btn-field-delete-modal-yes"
            disabled={isLoading}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteField;
